import {
  AfterSubmitFunc,
  FormTemplate,
  TextInput,
} from 'ui-builder';
import {
  DetailsFieldsSet,
  TeamPermission,
  UpdateDetailsSetFieldRequest,
  useDetailsFieldsSetsService
} from 'nekst-api';
import React from 'react';
import { useAuthorizationChecker } from 'authorization-scope';
import ContractExampleFileUploader from './ContractExampleFileUploader';


export default function UpdateDetailsFieldsSetForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    detailsSet: DetailsFieldsSet,
  }
) {
  const setsService = useDetailsFieldsSetsService();

  const { isGranted } = useAuthorizationChecker();

  return (
    <FormTemplate<UpdateDetailsSetFieldRequest, DetailsFieldsSet>
      title={`Update Set "${props.detailsSet.name}"`}
      submitFormFunc={async (data) => {
        return setsService.updateSet(props.detailsSet.id, data);
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={props.detailsSet}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            maxLength: 40,
          },
        },
        contractDocumentValidationFileId: {
          type: 'int',
          constraints: {
            required: {
              value: true,
              when: {
                contractDocumentExampleFileId: {
                  notEmpty: true,
                }
              }
            }
          }
        }
      }}
    >
      <TextInput source="name" label="Name" />
      {isGranted(TeamPermission.MANAGE_AI_TRAINING_DATA) && (
        <ContractExampleFileUploader />
      )}
    </FormTemplate>
  );
}
